import { render, staticRenderFns } from "./EditPrestation.vue?vue&type=template&id=5266129c&"
import script from "./EditPrestation.vue?vue&type=script&lang=ts&"
export * from "./EditPrestation.vue?vue&type=script&lang=ts&"
import style0 from "./EditPrestation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports